<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-table
          :items="itemsComputed"
          :fields="fields"
          striped
          bordered
          responsive
        >
          <template
            slot="discount"
            slot-scope="data"
          >
            <div class="col-right">
              {{ data.item.value }} {{ data.item.discount_type === 'percent' ? '%' : 'บาท' }}
            </div>
          </template>
          <template
            slot="status"
            slot-scope="data"
          >
            <div class="col-center">
              <b-badge
                :variant="promotionStatus(data.item.start_date, data.item.end_date) ? 'success' : 'warning'"
                class="mx-2"
              >
                {{ promotionStatusMessage(data.item.start_date, data.item.end_date) }}
              </b-badge>
              <!--              <b-badge-->
              <!--                :variant="data.item.active ? 'success' : 'danger'"-->
              <!--                class="mx-2"-->
              <!--              >-->
              <!--                {{ data.item.active ? 'เปิดการใช้งานอยู่' : 'ปิดการใช้งานอยู่' }}-->
              <!--              </b-badge>-->
            </div>
          </template>
          <template
            slot="active"
            slot-scope="data"
          >
            <div class="col-center">
              <b-form-checkbox
                v-model="data.item.active"
                :name="`active-promotion-${data.item.id}`"
                switch
                @change="activeHandler(data.item.id)"
              >
                ใช้งาน
              </b-form-checkbox>
            </div>
          </template>
          <template
            slot="action"
            slot-scope="data"
          >
            <b-button
              class="mx-2"
              variant="warning"
              @click="editFormHandler(data.item.id)"
            >
              แก้ไข
            </b-button>
            <b-button
              variant="danger"
              class="mx-2"
              @click="deleteDataConfirm(data.item.id)"
            >
              ลบ
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "PromotionTable",
    props: {
      items: {
        type: Array,
        default: () => []
      },
      updateDataHandler: {
        type: Function,
        default: () => false
      },
      deleteDataHandler: {
        type: Function,
        default: () => false
      },
      contentHandler: {
        type: Function,
        default: () => false
      },
      getDataHandler: {
        type: Function,
        default: () => false
      }
    },
    data() {
      return {
        fields: [
          {
            name: 'ชื่อ',
            key: 'name'
          },
          {
            name: 'รายละเอียด',
            key: 'description'
          },
          {
            name: 'จำนวนลด',
            key: 'discount'
          },
          {
            name: 'สถานะ',
            key: 'status'
          },
          {
            name: 'Active',
            key: 'active'
          },
          {
            name: 'Action',
            key: 'action'
          }
        ],
      }
    },
    computed: {
      itemsComputed: {
        get() {
          return this.items
        },
        set(value) {
          this.$emit('update:items', value)
        }
      }
    },
    methods: {
      async activeHandler(id) {
        const rowUpdate = this.itemsComputed.find(item => item.id === id)
        const rowIndex = this.itemsComputed.findIndex(item => item.id === id)
        if (!rowUpdate) {
          await this.$swal.fire('เกิดข้อผิดพลาด', 'id ไม่ถูกต้อง', 'error')
          this.$store.state.isLoading = false
          return
        }
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          await this.updateDataHandler(id, null, password)
        } else {
          this.itemsComputed[rowIndex].active = !this.itemsComputed[rowIndex].active
        }
      },
      promotionStatusMessage(startDateInput, endDateInput) {
        return this.promotionExpireCheck(startDateInput, endDateInput).message
      },
      promotionStatus(startDateInput, endDateInput) {
        return this.promotionExpireCheck(startDateInput, endDateInput).status
      },
      promotionExpireCheck(startDateInput, endDateInput) {
        const startDate = moment(startDateInput)
        const endDate = moment(endDateInput)
        const nowDate = moment()
        if (nowDate.isBefore(startDate)) {
          // not available
          return { status: false, message: `สามารถใช้งานได้วันที่ ${startDate.format('DD-MM-YYYY')}`}
        } else if (nowDate.isAfter(endDate)) {
          // expire
          return { status: false, message: `หมดอายุ`}
        } else {
          // between
          return { status: true, message: `สามารถใช้งานได้`}
        }
      },
      async editFormHandler(id) {
        await this.getDataHandler(id)
        this.contentHandler('form')
      },
      async deleteDataConfirm(id) {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          await this.deleteDataHandler(id, password)
        } else {
          return
        }
      }
    }
  }
</script>

<style scoped>

</style>